import * as React from 'react';
import {Component, ReactElement} from 'react';
import {RouteComponentProps} from 'react-router';
import {trackOnce} from '../../../utils/tracker';
import {AuthSignUpForm as SignUpForm, SIGNUP_FORM_DATA} from '../sign-up-form/sign-up-form';
import {AuthContent as Content} from '../content';
import {AuthFooter as Footer} from '../footer';
import {AuthHeader as Header} from '../header';
import {AuthLabel as Label} from '../label';
import {AuthModal as Modal} from '../modal/modal';
import {AuthLink as Link} from '../link/link';
import {INSTITUTION, USER_EMAIL} from '../../../utils/config';
import {ISignUpUdacityConnected, ISignUpUdacityActions} from './types';

const UDACITY_AUTH_URL = '/auth/udacity';

export interface IAuthSignUpUdacityProps
  extends ISignUpUdacityConnected, ISignUpUdacityActions, RouteComponentProps<{}> {}

export class AuthSignUpUdacity extends Component<IAuthSignUpUdacityProps> {
  public render(): ReactElement<any> {
    if (INSTITUTION || !USER_EMAIL) {
      return null;
    }

    const {history, register, ...props} = this.props;

    return (
      <Modal
        label={'Sign Up via Udacity'}
        onClose={() => history.push('/')}
      >
        <Header>Sign Up via Udacity</Header>

        <Content>
          <SignUpForm
            emailDisabled
            formData={{...SIGNUP_FORM_DATA, email: USER_EMAIL}}
            onSend={(data) => register(data)}
            {...props}
          />
        </Content>

        <Footer>
          <Label>Already a member?</Label>
          <Link url={'/sign-in'}>Log in</Link>
        </Footer>
      </Modal>
    );
  }

  public componentDidMount(): void {
    if (!USER_EMAIL) {
      window.location.href = UDACITY_AUTH_URL;
    }

    trackOnce('signup');
  }
}
